import { Field, FieldProps } from 'formik';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { ToggleInputType, ToggleOptionData } from '..';
import { Label } from '../../label';

export const BoxToggle = (props: ToggleInputType) => {
  const CustomComponent: FC<FieldProps> = ({ ...formikFieldProps }) => {
    const ToggleButton = ({ givenValue, displayName, image }: { givenValue: boolean } & ToggleOptionData) => {
      const isSelected = formikFieldProps.field.value === givenValue;
      const bgClass = isSelected ? 'primary' : 'white';
      const hoverBgClass = isSelected ? '' : 'blue-100';
      const textColorClass = isSelected ? 'white' : 'primary';

      return (
        <div
          className={twMerge(
            `flex-1 cursor-pointer rounded-md py-3 text-center transition-all bg-${bgClass} hover:bg-${hoverBgClass} text-${textColorClass} ${props.className}`,
          )}
          onClick={() => {
            formikFieldProps.form.setFieldValue(props.name, givenValue);
          }}
        >
          {image && <img src={image} alt={displayName} className=" mx-auto mb-1 h-10 w-10 lg:h-16 lg:w-16" />}
          {displayName || (givenValue ? 'Yes' : 'No')}
        </div>
      );
    };
    if (props.options && (props.options.length > 2 || props.options.length < 1)) {
      throw new Error('toggle options length should be 2');
    }

    return (
      <div>
        <Label name={props.name} label={props.label} />
        <div
          className="border-grey-200 flex rounded-lg border bg-white p-0.5"
          style={
            props.isMaxWidth
              ? { maxWidth: 'auto' }
              : {
                  maxWidth: 300,
                }
          }
        >
          <ToggleButton givenValue={true} {...(props.options?.length ? props.options[0] : {})} />
          <ToggleButton givenValue={false} {...(props.options?.length ? props.options[1] : {})} />
        </div>
      </div>
    );
  };
  return <Field name={props.name} component={CustomComponent} />;
};
